module.exports = __webpack_public_path__ + "static/img/222.6e94757.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/222.png
// module id = 5GGv
// module chunks = 0